import { useEffect, useRef, useState } from "react";
import { Gift } from "lucide-react";

function useCountUp(target, ms = 1400) {
  const [n, setN] = useState(0);
  const from = useRef(0);
  useEffect(() => {
    const start = performance.now();
    const a = from.current;
    let raf;
    const tick = (t) => {
      const k = Math.min(1, (t - start) / ms);
      const e = 1 - Math.pow(1 - k, 3);
      setN(Math.round(a + (target - a) * e));
      if (k < 1) raf = requestAnimationFrame(tick); else from.current = target;
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, ms]);
  return n;
}

export default function PrizeJackpot({ count, accent, scope }) {
  const n = useCountUp(count ?? 0);
  if (count == null) return null;
  const digits = String(n).padStart(2, "0").split("");
  return (
    <div className="mx-auto mb-5 flex w-fit items-center gap-3 rounded-2xl border border-amber-300/50 bg-black/45 px-4 py-2.5 shadow-[0_0_30px_rgba(251,191,36,.35)] backdrop-blur" data-testid="prize-jackpot">
      <Gift className="h-6 w-6 text-amber-300 jackpot-pulse" />
      <div className="flex gap-1" aria-label={`${count} premi disponibili oggi`}>
        {digits.map((d, i) => (
          <span key={i} className="grid h-11 w-8 place-items-center rounded-md bg-gradient-to-b from-slate-800 to-slate-950 font-display text-2xl font-extrabold text-amber-300 shadow-inner border border-amber-400/40" data-testid={`jackpot-digit-${i}`}>{d}</span>
        ))}
      </div>
      <div className="text-left leading-tight">
        <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-amber-200">Premi ancora</p>
        <p className="text-sm font-bold text-white" data-testid="prize-jackpot-scope">{scope === "store" ? "in questa sede oggi" : "disponibili oggi"}</p>
      </div>
    </div>
  );
}
